module.exports = __webpack_public_path__ + "static/media/facebook-card.7b9b4053.JPG";